import React from "react";
import Navbar from "../Navbar/Navbar";
import { useState,useEffect } from "react";
import { API } from "../../Redux/actions/API";
import { toast } from "react-toastify";

function Update_HomePageCoin() {
  
    const [name,setName]=useState('')
    const [symbol,setSymbol]=useState('')
    const [description,setDesc]=useState('')
    const [rate,setRate]=useState('')
    //const[rowid,setrowid]=useState(0);
    
    const searchParams = new URLSearchParams(window.location.search);
    localStorage.setItem("rowidAdmin",searchParams.get('id'))  ;

    const HomePageCoin_API = async () => {
      try {
       let rowid=localStorage.getItem("rowidAdmin");

        let res = await API.get(`/GetAllHomePageToken?id=` + rowid);
        console.log("res GetAllHomePageToken Admin", res.data.data);
        res=res.data.data;
        

        setName(res[0].coin_name);
        setSymbol(res[0].coin_url);
        setDesc(res[0].name);
        setRate(res[0].rate_value);
                
      } catch (e) {
        console.log("Error While calling Myteam API", e);
      }
    };

    const referral_API = async () => {
    //console.log("res   Update",name ,symbol ,description ,rate , rowid)
    let rowid=localStorage.getItem("rowidAdmin");
      if(name&&symbol&&description&&rate && rowid){
        try {
          let responceRight = await API?.post("/UpdateTokenMasterByAdmin", {
            "coin_name": name,
            "name": description,
            "coin_url":symbol ,
            "rate_value":rate,
            "rowid":rowid
          });
    
          console.log("My_Team", responceRight);
          if(responceRight.data.data==='Update Token Sucessfull.'){
          toast.success(responceRight.data.data)
          window.location.reload();
          }else{
          toast.error(responceRight.data.data)
          }
        } catch (e) {
          console.log("Error While calling Myteam API", e);
        }
      }else{
        toast.error('Please Fill All The Fields')
      }
      };
  

      const handleName=(e)=>{
        const result=e.target.value.replace(/[^a-z]/gi,'')
        setName(result)
      }

      const handleSymbol=(e)=>{
        //const result=e.target.value.replace(/[^a-z/]/gi,'')
        setSymbol(e.target.value)
      }

      
      const handleDesc=(e)=>{
        const result=e.target.value.replace(/[^a-z0-9 ]/gi,'')
        setDesc(result)
      }
      
      
  useEffect(() => {
  

    HomePageCoin_API();
  }, []);

  return (

    <div>
      <Navbar />
      <div class="content-page">
        <div
          id="content"
          class="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl"
        >
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">Update Home Page Coin </h4>
            </div>
            <div
              class="panel-body table-rep-plugin"
              style={{ padding: "8px", overflowY: "scroll" }}
            >
              <div class="row">
                <div class="box col-md-12">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-6 mr-30">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <h1 className="fw-bold">Update Home Page Coin </h1>
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                {/* <!---onclick number increase start--> */}

                                <div className="form-group">
                                  <label>Coin Name</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    name="Coin"
                                    placeholder="Coin Name"
                                    value={name}
                                    onChange={(e)=>handleName(e)}
                                    maxLength="10"
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Coin Image URL</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    name="Coin"
                                    placeholder="Coin Image URL"
                                    value={symbol}
                                    onChange={(e)=>handleSymbol(e)}
                                    maxLength="60"
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Description </label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    name="Coin"
                                    placeholder="Coin Description"
                                    value={description}
                                    onChange={(e)=>handleDesc(e)}
                                    maxLength="50"
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Coin Rate</label>
                                  <input
                                    type="text"
                                  //  inputMode="numeric"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Coin Rate like as : 0.39%-70.26% "
                                    maxLength="20"
                                    value={rate}
                                    onChange={(e)=>setRate(e.target.value)}
                                  />
                                </div>

                                <div class="joinbtn d-flex flex-row-reverse me-auto">
                                  <button
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 20px",
                                      marginTop: "20px",
                                    }}
                                    onClick={()=>referral_API()}
                                  >
                                    Update
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Update_HomePageCoin